import { Button, Checkbox, Col, DatePicker, DatePickerProps, Form, Input, InputNumber, Row, Select, Space, Table, Tag } from "antd";
import Column from "antd/es/table/Column";
import dayjs, { Dayjs } from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { PlusOutlined, SaveOutlined, DeleteOutlined } from '@ant-design/icons';
import { ContentHeader } from "../../components";
import ModalTextForm from "../../components/modal/ModalTextForm";
import { Links } from "../../helpers/Links";
import { dateCommon, validateMessages } from '../../helpers/common';
import { DanhSachKhenThuongUngHoResponse } from "../../models/luong/Luong";
import {
    khoiTaoLuongThang,
    layDsKhenThuongUngHoTheoNam,
    layDsLuongThang,
    layDsLuongCoBanTheoNam,
    layDsBangLuongPhuCapTheoNam,
    layDsLuongThemGioTheoNam,
    layDsLuongHoanThanhNhiemVuTheoNam,
    layDsLuongBoSungTruongBKSTheoNam,
    layDsPhuCapTGVTheoNam,
    xoaBangLuong,
} from "../../services/luong";
import { hideLoadingScreen, showLoadingScreen } from "../../store/reducers/loading";
import { layDsThuLaoKCTTheoNam } from "../../services/thulaokhongchuyentrach";
import { layDanhSachKyThueKhongThuongXuyen, layDsThueThangTheoNam } from "../../services/thue";

interface LuongItem {
    id: number;
    thangNam: string;
    thang: number;
    nam: number;
    dot?: number;
    congThang: number;
    tenKyLuong: string;
    ghiChu?: string;
    ngayKhoiTao: string;
    ngayCapNhat?: string;
    tenNVKhoiTao?: string;
    trangThai?: number;
}

const DanhSachLuong = () => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();

    const ngayHienTai = (dayjs()).date() <= 10 ? (dayjs()).subtract(1, 'month') : dayjs();

    const [loading, setLoading] = useState<boolean>(false);
    const [dataDs, setDataDs] = useState<Array<LuongItem>>([]);
    const [ngayThang, setNgayThang] = useState<Dayjs | null>(null);

    const [openModalKhoiTao, setOpenModalKhoiTao] = useState<boolean>(false);
    const [kyLuongKhoiTao, setKyLuongKhoiTao] = useState<Dayjs | null>(ngayHienTai);

    const [idXoa, setIdXoa] = useState<number>(0);
    const [openModalXoa, setOpenModalXoa] = useState<boolean>(false);

    const [dsKhenThuongUngHo, setDsKhenThuongUngHo] = useState<Array<DanhSachKhenThuongUngHoResponse>>([]);
    const [dsLuongCoBan, setDsLuongCoBan] = useState<Array<any>>([]);
    const [dsLuongPhuCap, setDsLuongPhuCap] = useState<Array<any>>([]);
    const [dsLuongThemGio, setDsLuongThemGio] = useState<Array<any>>([]);
    const [dsLuongHTNV, setDsLuongHTNV] = useState<Array<any>>([]);
    const [dsLuongBSTBKS, setDsLuongBSTBKS] = useState<Array<any>>([]);
    const [dsLuongThuLaoKCT, setDsLuongThuLaoKCT] = useState<Array<any>>([]);
    const [dsLuongPhuCapTGV, setDsLuongPhuCapTGV] = useState<Array<any>>([]);
    const [dsThueTNCN, setDsThueTNCN] = useState<Array<any>>([]);
    const [dsThueKTX, setDsThueKTX] = useState<Array<any>>([]);

    const [namLocKhenThuong, setNamLocKhenThuong] = useState<Dayjs | null>(null);
    const [namLocLuongCoBan, setNamLocLuongCoBan] = useState<Dayjs | null>(null);
    const [namLocLuongPhuCap, setNamLocLuongPhuCap] = useState<Dayjs | null>(null);
    const [namLocLuongThemGio, setNamLocLuongThemGio] = useState<Dayjs | null>(null);
    const [namLocLuongHTNV, setNamLocLuongHTNV] = useState<Dayjs | null>(null);
    const [namLocLuongBSTBKS, setNamLocLuongBSTBKS] = useState<Dayjs | null>(null);
    const [namLocLuongThuLaoKCT, setNamLocLuongThuLaoKCT] = useState<Dayjs | null>(null);
    const [namLocLuongPhuCapTGV, setNamLocLuongPhuCapTGV] = useState<Dayjs | null>(null);
    const [namLocThueTNCN, setNamLocThueTNCN] = useState<Dayjs | null>(null);
    const [namLocThueKTX, setNamLocThueKTX] = useState<Dayjs | null>(null);

    const monthFormat = 'MM/YYYY';
    const thangNamFormat: DatePickerProps['format'] = (value) => `Tháng ${value.format(monthFormat)}`;

    const layDuLieu = async (thangNam?: string) => {
        setLoading(true);
        try {
            const rs = await layDsLuongThang(0, 1000, thangNam);
            setDataDs(rs?.data ?? []);
        } catch (err: any) {
            toast.error(err?.toString().replace("Error: ", ""));
        }
        setLoading(false);
    };

    // Hàm lấy ds từng thành phần theo năm
    const layDsThanhPhanTheoNam = async (nam?: number) => {
        try {
            const [ktuh, lcb, lpc, ltg, htnv, bstbks, tlkct, pctgv, ttncn, tktx] = await Promise.all([
                layDsKhenThuongUngHoTheoNam(nam),
                layDsLuongCoBanTheoNam(nam),
                layDsBangLuongPhuCapTheoNam(nam),
                layDsLuongThemGioTheoNam(nam),
                layDsLuongHoanThanhNhiemVuTheoNam(nam),
                layDsLuongBoSungTruongBKSTheoNam(nam),
                layDsThuLaoKCTTheoNam(nam),
                layDsPhuCapTGVTheoNam(nam),
                layDsThueThangTheoNam(nam),
                layDanhSachKyThueKhongThuongXuyen(nam ? nam.toString() : ""),
            ]);
            setDsKhenThuongUngHo((ktuh ?? []).filter(x => x.loaiUngHo !== 2));
            setDsLuongCoBan(lcb ?? []);
            setDsLuongPhuCap(lpc ?? []);
            setDsLuongThemGio(ltg ?? []);
            setDsLuongHTNV(htnv ?? []);
            setDsLuongBSTBKS(bstbks ?? []);
            setDsLuongThuLaoKCT(tlkct ?? []);
            setDsLuongPhuCapTGV(pctgv ?? []);
            setDsThueTNCN(ttncn ?? []);
            setDsThueKTX(tktx ?? []);
        } catch (err: any) {
            toast.error(err?.toString().replace("Error: ", ""));
        }
    };

    useEffect(() => {
        layDuLieu(undefined);
    }, []);

    const onChangeThangNam: DatePickerProps['onChange'] = (date) => {
        setNgayThang(date);
        layDuLieu(date ? date.format('MM/YYYY') : undefined);
    };

    const onChangeLoaiFilter = (val: number | undefined) => {
        layDuLieu(ngayThang ? ngayThang.format('MM/YYYY') : undefined);
    };

    const capNhatTieuDeGoiY = (date: Dayjs | null, dotVal?: number) => {
        if (!date) return;
        const currentDot = dotVal ?? form.getFieldValue('dot') ?? 1;
        const autoTitle = `BẢNG TỔNG HỢP THU NHẬP THÁNG ${date.month() + 1} NĂM ${date.year()} - ĐỢT ${currentDot}`;
        form.setFieldValue('tenKyLuong', autoTitle);
    };

    const onMoModalKhoiTao = async () => {
        const ky = ngayThang ?? ngayHienTai;
        setKyLuongKhoiTao(ky);
        const namKy = dayjs().year(ky.year());
        setNamLocKhenThuong(namKy);
        setNamLocLuongCoBan(namKy);
        setNamLocLuongPhuCap(namKy);
        setNamLocLuongThemGio(namKy);
        setNamLocLuongHTNV(namKy);
        setNamLocLuongBSTBKS(namKy);
        setNamLocLuongThuLaoKCT(namKy);
        setNamLocLuongPhuCapTGV(namKy);
        setNamLocThueTNCN(namKy);
        setNamLocThueKTX(namKy);

        // Đếm số đợt hiện có trong tháng để gợi ý đợt tiếp theo
        const thangNamStr = ky.format('MM/YYYY');
        const dsTrongThang = dataDs.filter(x => x.thangNam && dayjs(x.thangNam).format('MM/YYYY') === thangNamStr);
        const dotGoiY = dsTrongThang.length > 0 ? Math.max(...dsTrongThang.map(x => x.dot || 1)) + 1 : 1;
        const tieuDeMacDinh = `BẢNG TỔNG HỢP THU NHẬP THÁNG ${ky.month() + 1} NĂM ${ky.year()} - ĐỢT ${dotGoiY}`;

        form.setFieldsValue({
            kyLuong: ky,
            dot: dotGoiY,
            tenKyLuong: tieuDeMacDinh,
            ghiChu: "",
            dsIdLuongKhenThuongUngHo: [],
            dsIdLuongCoBan: [],
            dsIdLuongPhuCap: [],
            dsIdLuongThemGio: [],
            dsIdLuongHTNV: [],
            dsIdLuongBSTBKS: [],
            dsIdLuongThuLaoKCT: [],
            dsIdLuongPhuCapTGV: [],
            dsIdThueTNCN: [],
            dsIdThueKTX: [],
        });
        await layDsThanhPhanTheoNam(ky.year());
        setOpenModalKhoiTao(true);
    };

    const onChangeKyLuongKhoiTao = (date: Dayjs | null) => {
        setKyLuongKhoiTao(date);
        capNhatTieuDeGoiY(date);
    };

    const onChangeDotKhoiTao = (val: number | null) => {
        const ky = form.getFieldValue('kyLuong');
        if (ky) {
            capNhatTieuDeGoiY(ky, val ?? 1);
        }
    };

    // Helper tạo handler đổi năm lọc cho từng thành phần
    const taoOnChangeNamLoc = (
        setNamLoc: (d: Dayjs | null) => void,
        fieldName: string,
        fetchFn: (nam?: number) => Promise<void>
    ) => async (date: Dayjs | null) => {
        setNamLoc(date);
        form.setFieldsValue({ [fieldName]: [] });
        await fetchFn(date ? date.year() : undefined);
    };

    const onFinishKhoiTao = async (values: any) => {
        dispatch(showLoadingScreen());
        try {
            const ky = values?.kyLuong as Dayjs;
            const request = {
                thangNam: ky.format('MM/YYYY'),
                dot: values?.dot ?? 1,
                tenKyLuong: values?.tenKyLuong ?? '',
                ghiChu: values?.ghiChu ?? '',
                dsIdLuongKhenThuongUngHo: (values?.dsIdLuongKhenThuongUngHo ?? []) as number[],
                dsIdLuongCoBan: (values?.dsIdLuongCoBan ?? []) as number[],
                dsIdLuongPhuCap: (values?.dsIdLuongPhuCap ?? []) as number[],
                dsIdLuongThemGio: (values?.dsIdLuongThemGio ?? []) as number[],
                dsIdLuongHTNV: (values?.dsIdLuongHTNV ?? []) as number[],
                dsIdLuongBSTBKS: (values?.dsIdLuongBSTBKS ?? []) as number[],
                dsIdLuongThuLaoKCT: (values?.dsIdLuongThuLaoKCT ?? []) as number[],
                dsIdLuongPhuCapTGV: (values?.dsIdLuongPhuCapTGV ?? []) as number[],
                dsIdThueTNCN: (values?.dsIdThueTNCN ?? []) as number[],
                dsIdThueKTX: (values?.dsIdThueKTX ?? []) as number[],
            };
            const rs = await khoiTaoLuongThang(request);
            if (rs && rs.id > 0) {
                toast.success('Khởi tạo tổng hợp lương tháng thành công!');
                setOpenModalKhoiTao(false);
                layDuLieu(ngayThang ? ngayThang.format('MM/YYYY') : undefined);
            } else {
                toast.error('Khởi tạo tổng hợp lương tháng thất bại!');
            }
        } catch (err: any) {
            toast.error(err?.toString().replace("Error: ", ""));
        }
        dispatch(hideLoadingScreen());
    };

    const handleXoa = async () => {
        if (!idXoa || idXoa <= 0) return;
        dispatch(showLoadingScreen());
        try {
            await xoaBangLuong(idXoa);
            toast.success('Xóa bảng tổng hợp lương thành công');
            setOpenModalXoa(false);
            setIdXoa(0);
            layDuLieu(ngayThang ? ngayThang.format('MM/YYYY') : undefined);
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    // Helper render 1 row chọn thành phần (năm lọc + select multiple)
    const renderThanhPhanRow = (
        label: string,
        fieldName: string,
        namLoc: Dayjs | null,
        onChangeNam: (d: Dayjs | null) => void,
        options: { value: number; label: string }[]
    ) => (
        <Row gutter={8}>
            <Col span={8}>
                <Form.Item label={`Năm ${label}`}>
                    <DatePicker
                        changeOnBlur={true}
                        picker="year"
                        placeholder="Năm (để trống = tất cả)"
                        style={{ width: "100%" }}
                        value={namLoc}
                        onChange={onChangeNam}
                    />
                </Form.Item>
            </Col>
            <Col span={16}>
                <Form.Item label={label} name={fieldName}>
                    <Select
                        mode="multiple"
                        allowClear
                        placeholder={`Chọn ${label.toLowerCase()}`}
                        options={options}
                        notFoundContent="Không có dữ liệu"
                        filterOption={(input, option: any) =>
                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                        }
                    />
                </Form.Item>
            </Col>
        </Row>
    );

    const optionsKhenThuong = dsKhenThuongUngHo.filter(x => x.loaiUngHo !== 2).map(x => ({ value: x.id, label: `${x.ten} (${x.thoiGian})` }));
    const optionsLuongCoBan = dsLuongCoBan.map(x => ({ value: x.id, label: x.tenKyLuong }));
    const optionsLuongPhuCap = dsLuongPhuCap.map(x => ({ value: x.id, label: x.tenKyLuong }));
    const optionsLuongThemGio = dsLuongThemGio.map(x => ({ value: x.id, label: x.tenKyLuong }));
    const optionsLuongHTNV = dsLuongHTNV.map(x => ({ value: x.id, label: x.tenKyLuong }));
    const optionsLuongBSTBKS = dsLuongBSTBKS.map(x => ({ value: x.id, label: x.tenKyLuong }));
    const optionsLuongThuLaoKCT = dsLuongThuLaoKCT.map(x => ({ value: x.id, label: x.ten }));
    const optionsLuongPhuCapTGV = dsLuongPhuCapTGV.map(x => ({ value: x.id, label: x.ten }));
    const optionsThueTNCN = dsThueTNCN.map(x => ({ value: x.id, label: x.tenKyThue || `Thuế TNCN tháng ${x.thang}/${x.nam}` }));
    const optionsThueKTX = dsThueKTX.map(x => ({ value: x.id, label: x.kyThue || `Thuế KTX ${x.loaiChuKy === 1 ? 'tháng ' + x.thang : 'quý ' + x.quy}/${x.nam}` }));

    return (
        <section>
            {openModalKhoiTao && (
                <ModalTextForm
                    title="Khởi tạo tổng hợp lương tháng"
                    hideFooter
                    dialogClassName="modal-75wh"
                    show={openModalKhoiTao}
                    handleClose={() => setOpenModalKhoiTao(false)}
                >
                    <Form layout="vertical" validateMessages={validateMessages} onFinish={onFinishKhoiTao} form={form}>
                        <Row gutter={8}>
                            <Col span={8}>
                                <Form.Item rules={[{ required: true, message: 'Vui lòng chọn kỳ lương' }]} label="Kỳ lương tổng hợp" name="kyLuong">
                                    <DatePicker
                                        changeOnBlur={true}
                                        picker="month"
                                        format={["MM/YYYY", "MMYYYY"]}
                                        placeholder="Chọn kỳ lương"
                                        style={{ width: "100%" }}
                                        onChange={onChangeKyLuongKhoiTao}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={4}>
                                <Form.Item rules={[{ required: true, message: 'Vui lòng nhập đợt' }]} label="Đợt" name="dot">
                                    <InputNumber
                                        min={1}
                                        style={{ width: "100%" }}
                                        placeholder="Đợt"
                                        onChange={onChangeDotKhoiTao}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item rules={[{ required: true, message: 'Vui lòng nhập tên tiêu đề' }]} label="Tên tiêu đề" name="tenKyLuong">
                                    <Input placeholder="Nhập tên tiêu đề kỳ lương" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={8}>
                            <Col span={24}>
                                <Form.Item label="Ghi chú" name="ghiChu">
                                    <Input.TextArea rows={3} placeholder="Nhập ghi chú (nếu có)" />
                                </Form.Item>
                            </Col>
                        </Row>

                        {renderThanhPhanRow("Tăng/Giảm", "dsIdLuongKhenThuongUngHo", namLocKhenThuong,
                            taoOnChangeNamLoc(setNamLocKhenThuong, "dsIdLuongKhenThuongUngHo", (nam) => layDsKhenThuongUngHoTheoNam(nam).then(data => setDsKhenThuongUngHo((data ?? []).filter(x => x.loaiUngHo !== 2)))),
                            optionsKhenThuong)}

                        {renderThanhPhanRow("Lương cơ bản", "dsIdLuongCoBan", namLocLuongCoBan,
                            taoOnChangeNamLoc(setNamLocLuongCoBan, "dsIdLuongCoBan", (nam) => layDsLuongCoBanTheoNam(nam).then(setDsLuongCoBan)),
                            optionsLuongCoBan)}

                        {renderThanhPhanRow("Phụ cấp", "dsIdLuongPhuCap", namLocLuongPhuCap,
                            taoOnChangeNamLoc(setNamLocLuongPhuCap, "dsIdLuongPhuCap", (nam) => layDsBangLuongPhuCapTheoNam(nam).then(setDsLuongPhuCap)),
                            optionsLuongPhuCap)}

                        {renderThanhPhanRow("Lương thêm giờ", "dsIdLuongThemGio", namLocLuongThemGio,
                            taoOnChangeNamLoc(setNamLocLuongThemGio, "dsIdLuongThemGio", (nam) => layDsLuongThemGioTheoNam(nam).then(setDsLuongThemGio)),
                            optionsLuongThemGio)}

                        {renderThanhPhanRow("Lương HTNV", "dsIdLuongHTNV", namLocLuongHTNV,
                            taoOnChangeNamLoc(setNamLocLuongHTNV, "dsIdLuongHTNV", (nam) => layDsLuongHoanThanhNhiemVuTheoNam(nam).then(setDsLuongHTNV)),
                            optionsLuongHTNV)}

                        {renderThanhPhanRow("Bổ sung Trưởng BKS", "dsIdLuongBSTBKS", namLocLuongBSTBKS,
                            taoOnChangeNamLoc(setNamLocLuongBSTBKS, "dsIdLuongBSTBKS", (nam) => layDsLuongBoSungTruongBKSTheoNam(nam).then(setDsLuongBSTBKS)),
                            optionsLuongBSTBKS)}

                        {renderThanhPhanRow("Thù lao không chuyên trách", "dsIdLuongThuLaoKCT", namLocLuongThuLaoKCT,
                            taoOnChangeNamLoc(setNamLocLuongThuLaoKCT, "dsIdLuongThuLaoKCT", (nam) => layDsThuLaoKCTTheoNam(nam).then(setDsLuongThuLaoKCT)),
                            optionsLuongThuLaoKCT)}

                        {renderThanhPhanRow("Phụ cấp tổ giúp việc", "dsIdLuongPhuCapTGV", namLocLuongPhuCapTGV,
                            taoOnChangeNamLoc(setNamLocLuongPhuCapTGV, "dsIdLuongPhuCapTGV", (nam) => layDsPhuCapTGVTheoNam(nam).then(setDsLuongPhuCapTGV)),
                            optionsLuongPhuCapTGV)}

                        {renderThanhPhanRow("Thuế TNCN (Thường xuyên)", "dsIdThueTNCN", namLocThueTNCN,
                            taoOnChangeNamLoc(setNamLocThueTNCN, "dsIdThueTNCN", (nam) => layDsThueThangTheoNam(nam).then(setDsThueTNCN)),
                            optionsThueTNCN)}

                        {renderThanhPhanRow("Thuế KTX", "dsIdThueKTX", namLocThueKTX,
                            taoOnChangeNamLoc(setNamLocThueKTX, "dsIdThueKTX", (nam) => layDanhSachKyThueKhongThuongXuyen(nam ? nam.toString() : "").then(setDsThueKTX)),
                            optionsThueKTX)}

                        <Form.Item>
                            <Button type="primary" className="float-right" htmlType="submit" icon={<SaveOutlined />}>
                                Khởi tạo
                            </Button>
                        </Form.Item>
                    </Form>
                </ModalTextForm>
            )}

            <ContentHeader title="Danh sách tổng hợp lương tháng" />

            <Row className="form-group" gutter={8}>
                <Col span={6}>
                    <DatePicker
                        changeOnBlur={true}
                        value={ngayThang}
                        style={{ width: "100%" }}
                        placeholder="Tháng tính lương"
                        picker="month"
                        format={thangNamFormat}
                        onChange={onChangeThangNam}
                    />
                </Col>
                <Col span={18}>
                    <Button className="hrm-btn hrm-btn-warning float-right" onClick={onMoModalKhoiTao} icon={<PlusOutlined />}>
                        Khởi tạo tổng hợp lương tháng
                    </Button>
                </Col>
            </Row>

            <Row gutter={8}>
                <Col span={24}>
                    <div className="card card-primary">
                        <Table
                            locale={{ emptyText: "Không có dữ liệu" }}
                            dataSource={(dataDs || []).map((value, index) => ({ key: index, ...value }))}
                            loading={loading}
                        >
                            <Column
                                title="Kỳ lương"
                                key="tenKyLuong"
                                render={(value) => <b>{value?.tenKyLuong}</b>}
                            />
                            <Column
                                title="Trạng thái"
                                key="trangThai"
                                render={(value) => {
                                    if (value?.trangThai === 2) return <Tag color="success">Đã xác nhận thực nhận</Tag>;
                                    if (value?.trangThai === 1) return <Tag color="warning">Đã xác nhận trước thuế</Tag>;
                                    return <Tag color="blue">Khởi tạo</Tag>;
                                }}
                            />
                            <Column title="Người khởi tạo" key="tenNVKhoiTao" render={(value) => <div>{value?.tenNVKhoiTao}</div>} />
                            <Column title="Ngày khởi tạo" key="ngayKhoiTao" render={(value) => <div>{dateCommon.formatDate(value?.ngayKhoiTao)}</div>} />
                            <Column
                                title=""
                                key="action"
                                render={(value, _record, index) => (
                                    <Space key={"action" + index}>
                                        <Link className="hrm-btn hrm-btn-sm btn-primary" to={`${Links.Luong.QuanLyLuong}?id=${value?.id}`}>
                                            Xem
                                        </Link>
                                        {value?.trangThai === 0 && (
                                            <Button
                                                size="small"
                                                type="primary"
                                                danger
                                                icon={<DeleteOutlined />}
                                                onClick={() => {
                                                    setIdXoa(value?.id);
                                                    setOpenModalXoa(true);
                                                }}
                                            >
                                                Xóa
                                            </Button>
                                        )}
                                    </Space>
                                )}
                            />
                        </Table>
                    </div>
                </Col>
            </Row>

            <ModalTextForm
                show={openModalXoa}
                title="Xác nhận xóa bảng tổng hợp lương"
                handleClose={() => setOpenModalXoa(false)}
                handleSave={handleXoa}
            >
                Bạn có chắc chắn muốn xóa bảng tổng hợp lương này không?
            </ModalTextForm>
        </section>
    );
};

export default DanhSachLuong;